var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMake = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 64,
  height: 64,
  fill: "none",
  viewBox: "0 0 64 64"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#make_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#6D01CB",
  d: "M32 64c17.673 0 32-14.327 32-32S49.673 0 32 0 0 14.327 0 32s14.327 32 32 32"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M21.178 19.404 10.386 40.902c-.233.436-.03.989.407 1.192l5.818 2.939a.897.897 0 0 0 1.222-.408l10.792-21.498a.897.897 0 0 0-.407-1.222L22.4 18.967a.857.857 0 0 0-1.193.408zM40.32 19.084h6.516c.495 0 .902.407.902.901v24.059a.906.906 0 0 1-.902.901H40.32a.906.906 0 0 1-.902-.901V19.985c0-.494.407-.901.902-.901M30.284 19.462 25.658 42.88c-.087.495.233.96.698 1.047l6.4 1.28a.945.945 0 0 0 1.077-.698l4.625-23.418c.087-.495-.233-.96-.698-1.047l-6.4-1.28c-.495-.088-.96.203-1.047.698z"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "make_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h64v64H0z"
})))));
export default SvgMake;